import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { isFutureFromToday, isPastFromToday } from "../../../../helpers";
import {
  addCodeData,
  changeSettingValue,
  codeListData,
  deleteCodeData,
} from "../../../../Redux/actions";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import LoadingBtn from "../../../Components/LoadingBtn";
import LoadingIcon from "../../../Components/LoadingIcon";
const Codes = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    code_list,
    is_delete_btn_loading,
    is_delete_btn_id,
    is_add_btn_loading,
  } = useSelector((state) => state.settingReducer);

  useEffect(() => {
    dispatch(codeListData());
    return () => {
      dispatch(changeSettingValue("code_list", null));
    };
  }, []);

  const getStatus = (code) => {
    let res = "Active";
    if (code?.used_by > 0) {
      res = "Used";
    } else if (
      moment(moment(code?.created)).isBefore(
        moment().subtract("23:59:59").format("yyyy-MM-DD HH:mm:ss"),
        "day"
      )
    ) {
      res = "Expired";
    }
    return res;
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="col-12 my-3 mx-0 px-0">
                <LoadingBtn
                  className="btn btn_btnblue float-end SaveBtn"
                  onClick={() => dispatch(addCodeData())}
                  is_loading={is_add_btn_loading}
                >
                  Add Code
                </LoadingBtn>
              </div>
              <div className="shadowclass mt-0">
                <div className="table-responsive">
                  <table className="checklist-table remove-space inventory_table">
                    <thead>
                      <tr>
                        <th>
                          <a>Code</a>{" "}
                        </th>
                        <th>Used By</th>
                        <th>Created Date</th>
                        <th>Status</th>
                        <th class="action-td">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {code_list &&
                        code_list.length > 0 &&
                        code_list.map((code) => {
                          return (
                            <tr>
                              <td>{code?.code ?? ""}</td>
                              <td>{code?.merchant?.company_name ?? ""}</td>
                              <td>{code?.created ?? ""}</td>
                              <td>{getStatus(code)}</td>
                              <td className="action-td">
                                {code?.used_by == 0 && (
                                  <a
                                    class="deletePm circle_icon red"
                                    onClick={() =>
                                      dispatch(
                                        deleteCodeData({
                                          id: code?.id,
                                        })
                                      )
                                    }
                                  >
                                    <LoadingIcon
                                      is_loading={
                                        is_delete_btn_loading &&
                                        is_delete_btn_id == code?.id
                                      }
                                      className="iconSprites delete-icon"
                                    />
                                  </a>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Codes;
